import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"font-family":"'Public Sans'","text-align":"left","margin-bottom":"32px"} }, " Demographics information is taken from your profile, together with the information provided by your company. ", -1)
const _hoisted_2 = {
  key: 0,
  class: "grid grid-rows-5 grid-flow-col gap-4 text-start"
}
const _hoisted_3 = { class: "font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.activeQuestion < 10)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionnaireFields, (question) => {
            return (_openBlock(), _createElementBlock("div", {
              key: question.id,
              class: ""
            }, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$tc(question.label)), 1),
              _createElementVNode("div", null, [
                (question.type === 'text')
                  ? (_openBlock(), _createBlock(_component_InputText, {
                      key: 0,
                      type: "text",
                      value: _ctx.formData[question.field],
                      onInput: (event) => _ctx.handleInputChange(question.field, event),
                      class: "demographics-field"
                    }, null, 8, ["value", "onInput"]))
                  : (_openBlock(), _createBlock(_component_Dropdown, {
                      key: 1,
                      modelValue: _ctx.formData[question.field],
                      "onUpdate:modelValue": (value) => _ctx.handleDropdownChange(question.field, value),
                      options: _ctx.getDropdownOptions(question.options),
                      "option-value": "id",
                      optionLabel: "name",
                      placeholder: "Select...",
                      class: "md:w-14rem level-ddl demographics-field"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}